module.exports = __webpack_public_path__ + "img/ic_arrow_menu_mobile.9e10e326.svg";